/**
 * Периоды отчётов по партнёрам (25.10.2026): даты — по Алматы, как в
 * снимках статистики. Месяц — календарный: так считают отчётность.
 */
export const PARTNER_PERIODS = [
  { value: '7', label: '7 дней' },
  { value: '30', label: '30 дней' },
  { value: 'this', label: 'Этот месяц' },
  { value: 'prev', label: 'Прошлый месяц' },
] as const;

export type PartnerPeriod = (typeof PARTNER_PERIODS)[number]['value'];

const almaty = (ms: number) => new Date(ms + 5 * 3600e3);
const iso = (d: Date) => d.toISOString().slice(0, 10);

export function periodRange(period: PartnerPeriod, now = Date.now()): { from: string; to: string } {
  const today = almaty(now);
  if (period === 'this') return { from: iso(new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1))), to: iso(today) };
  if (period === 'prev') {
    return {
      from: iso(new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - 1, 1))),
      to: iso(new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 0))),
    };
  }
  return { from: iso(almaty(now - (Number(period) - 1) * 86400e3)), to: iso(today) };
}

export const num = (n: number | null | undefined) => (n == null ? '—' : n.toLocaleString('ru-RU'));
export const postDay = (isoDate: string) =>
  new Date(isoDate).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', timeZone: 'Asia/Almaty' });
